import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { CollectionType } from 'src/domains/casino/types/types';
import { CasinoPromotions } from './CasinoPromotions';
import { CasinoNavigation } from './CasinoNavigation';
import { CasinoContent } from './CasinoContent';
import { SeoPagesContent } from 'src/domains/layouts/webview/components/seoPages/SeoPages';
import { XtremePushBanner } from 'src/domains/layouts/webview/components/xtremePush/xtremePushBanner/XtremePushBanner';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface CasinoCollectionPropsType {
    appCasinoState: AppCasinoState;
    collection: CollectionType;
    tabId: string | null;
}

export const CasinoCollection = observer('CasinoCollection', (props: CasinoCollectionPropsType): JSX.Element => {
    const { appCasinoState, collection, tabId } = props;
    const common = useCommon();
    const { xtremePush } = ConfigComponents.get(common).config;

    const casinoPageState = appCasinoState.casinoPageState.get(collection).get(tabId);
    const hideCategories = collection === 'virtuals';

    return (
        <div>
            <CasinoPromotions collection={collection} />
            {xtremePush ? <XtremePushBanner type='casino' /> : null}
            <CasinoNavigation
                casinoPageState={casinoPageState}
                hideCategories={hideCategories}
            />
            <CasinoContent
                appCasinoState={appCasinoState}
                casinoPageState={casinoPageState}
                collection={collection}
            />
            <SeoPagesContent pageSlug={collection} />
        </div>
    );
});
